<template>
  <div>
    <el-form ref="searchForm" :inline="true" :label-position="position">
      <el-form-item>

        <!-- <el-select v-model="selectValue" clearable placeholder="请选择">
          <el-option
            v-for="item in optionsData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->

         <!-- <el-input clearable class="text-input" v-model.trim="orderNo" placeholder="工单编号" style="margin-bottom: 10px;"></el-input> 
                    <el-input clearable class="text-input" v-model="customerName" placeholder="客户名称" style="margin-bottom: 10px;"></el-input>                    
                    <el-input clearable class="text-input" v-model="telephoneNo" placeholder="客户手机号" style="margin-bottom: 10px;"></el-input>
                    <el-input clearable class="text-input" v-model="address" placeholder="客户地址" style="margin-bottom: 10px;"></el-input>
                   <el-input clearable class="text-input" v-model="cityName" placeholder="城市" style="margin-bottom: 5px;"></el-input> -->
      <el-date-picker
          style="width: 245px;margin-bottom: 10px;"
          v-model.trim="valueTime1"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          range-separator="-"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="下单开始"
          end-placeholder="下单结束">
      </el-date-picker>
      <el-date-picker
          style="width: 245px;margin-bottom:10px"
          v-model.trim="valueTime2"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          range-separator="-"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="预约开始"
          end-placeholder="预约结束">
      </el-date-picker>
        <el-date-picker
          style="width: 245px;margin-bottom:10px"
          v-model.trim="valueTime3"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          range-separator="-"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="完成时间"
          end-placeholder="完成时间">
      </el-date-picker>
      <el-select clearable filterable @change="changeEnginner"  v-model="searchForm.engineerId" :filter-method="PinyinMatch" placeholder="工程师" style="width:110px;margin-bottom: 10px;margin-right: 10px">
        <el-option v-for="(item,index) in engineersList" 
          :key="index" 
          :label="item.name" 
          :value="item.id">
        </el-option>
      </el-select>             
      </el-form-item>
      <el-form-item>
        <el-button plain size="medium" @click="loadData" icon="fa fa-search"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div id="container"></div>
  </div>
</template>

<script>
import TXMap from "../../components/orderMap/TXMap";
import { queryOrderMap, engineerList } from "../../api/api";
import { hideLoading, showLoading } from "../../components/loading/loading";
import PinyinMatch from 'pinyin-match';

export default {
  data() {
    return {
      valueTime1:[],
      valueTime2:[],
      valueTime3:[],
      copy:[],
      engineersList:[],
      selectValue: "",
      optionsData: [
        {
          value: "d1",
          label: "今年所有手机完成订单"
        },
        {
          value: "d2",
          label: "今年所有手机未完成订单"
        },
        {
          value: "d3",
          label: "今年所有除手机以外完成订单"
        },
        {
          value: "d4",
          label: "今年所有除手机以外未完成订单"
        }
      ],
       searchForm:{
                    createTimeStart:'',
                    createTimeEnd:'',
                    onsiteTimeStart:'',
                    onsiteTimeEnd:'',
                    completeDateStart:'',
                    completeDateEnd:'',
                    engineerId:''
                },
      position: "left",
      longitude: 0, //经度
      latitude: 0, //纬度
      city: "shanghai",
      map: null,
      marker: null
    };
  },
  mounted() {
    TXMap.txMap({ containerId: "container", useLocation: true });
    this.getEngineerList();
    this.loadData();
  },
  methods: {
    loadData() {
      let _self = this;
      if(this.valueTime1 != null && this.valueTime1.length > 1 ){
        this.searchForm.createTimeStart = new Date(this.valueTime1[0])
        this.searchForm.createTimeEnd = new Date(this.valueTime1[1])
      }else{
          this.searchForm.createTimeStart = "";
          this.searchForm.createTimeEnd = "";
      }
      if(this.valueTime2 != null && this.valueTime2.length > 1 ){
          this.searchForm.onsiteTimeStart = new Date(this.valueTime2[0]);
          this.searchForm.onsiteTimeEnd = new Date(this.valueTime2[1]);
      }else{
          this.searchForm.onsiteTimeStart = "";
          this.searchForm.onsiteTimeEnd = "";
      }
      if(this.valueTime3 != null && this.valueTime3.length > 1 ){
          this.searchForm.completeDateStart = new Date(this.valueTime3[0]);
          this.searchForm.completeDateEnd = new Date(this.valueTime3[1]);
      }else{
          this.searchForm.completeDateStart = "";
          this.searchForm.completeDateEnd = "";
      }
      //const params = { d: this.searchForm };
      if (_self.marker) {
        _self.marker.setGeometries([]);
      }
      showLoading();
      queryOrderMap(this.searchForm)
        .then(res => {
          if (res.data.status == 100) {
            TXMap.marker({
              containerId: "container",
              useLocation: true,
              data: res.data.results
            });
          }
        })
        .finally(() => {
          hideLoading();
        });
    },
      //强制刷新
            changeEnginner(e){
                console.log(e);
                this.searchForm.engineerId = e;
                this.$forceUpdate();
            },
   //获取工程师
     getEngineerList(){
              
                let params = {
                    startRow:1,
                    pageSize:10000,
                    state:1
                }
                engineerList(params).then(res => {
                    if (res.data.status==100) {
                        this.engineersList = res.data.results.list;
                        this.copy = Object.assign(this.engineersList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
             //工程师拼音模糊搜索
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.engineerId = val;
                    this.engineersList = result;
                }else{
                    this.engineersList = this.copy;
                    this.searchForm.engineerId = "";
                }
            },
  }

           
};
</script>
<style>
/* #container {
  width: 98%;
  height: 100%;
  position: absolute;
} */
.clusterBubble1 {
       position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    text-align: center;
    line-height: 40px;
    box-shadow: rgb(0 0 0 / 20%) 0px 1px 1px 0px;
    border: 1px solid rgb(192,192,192);
    background-color: rgba(227, 235, 255, 0.9);
    font-size: 14px;
    color: rgb(192,192,192);
}
.clusterBubble2 {
       position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    text-align: center;
    line-height: 40px;
    box-shadow: rgb(0 0 0 / 20%) 0px 1px 1px 0px;
    border: 1px solid rgb(255,162,0);
    background-color: rgba(227, 235, 255, 0.9);
    font-size: 14px;
    color: rgb(255,162,0);
}
.clusterBubble3 {
       position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    text-align: center;
    line-height: 40px;
    box-shadow: rgb(0 0 0 / 20%) 0px 1px 1px 0px;
    border: 1px solid rgb(160,32,240);
    background-color: rgba(227, 235, 255, 0.9);
    font-size: 14px;
    color: rgb(160,32,240);
}
.clusterBubble4 {
       position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    text-align: center;
    line-height: 40px;
    box-shadow: rgb(0 0 0 / 20%) 0px 1px 1px 0px;
    border: 1px solid rgb(255,0,0);
    background-color: rgba(227, 235, 255, 0.9);
    font-size: 14px;
    color: rgb(255,0,0);
}
</style>



// WEBPACK FOOTER //
// orderMap.vue?53a20745